// Custom
require("packs/private/users/profile.js")
require("packs/private/users/profile_avatar.js")
require("packs/private/users/profile_files.js")
require("packs/private/oferts/sidebar_filter_mobile.js")
require("packs/private/users/profile_user_menu.js")
require("packs/private/users/profile_user_menu_mobile.js")
require("packs/private/postulations/postulations_filter_menu.js")
require("packs/private/postulations/assign.js")

// Validaciones para formularios
require("packs/private/validations/login.js");
require("packs/private/validations/register.js");
require("packs/private/validations/recover_password.js");
require("packs/private/validations/modify_password.js");
require("packs/private/validations/resend_activate.js");
require("packs/private/validations/activation.js");

// User
require("packs/private/users/my_postulations.js");
require("packs/private/oferts/oferts.js");
require("packs/private/postulations/postulations.js");
require("packs/private/users/update_password.js");
require("packs/private/users/delete_account.js");

// Admin
require("packs/private/admin/companies.js");
require("packs/private/admin/recruiters.js");
require("packs/private/admin/clients.js");
require("packs/private/admin/client_logo.js")
require("packs/private/admin/offer_banner.js")
require("packs/private/admin/client_profile_banner.js")
require("packs/private/admin/users.js")
require("packs/private/admin/universities.js")
require("packs/private/admin/local_careers.js")
require("packs/private/admin/oferts_top.js")
require("packs/private/admin/oferts_external.js")
require("packs/private/admin/client_plans.js")
require("packs/private/admin/services.js")
require("packs/private/admin/admins.js")
require("packs/private/admin/admins/wizard_form.js")
require("packs/private/admin/wizard_form_recruiter.js")
require("packs/private/admin/oferts.js")
require("packs/private/admin/postulations.js")
require("packs/private/admin/documents.js")
require("packs/private/admin/oferts_external_reject.js")

require("packs/private/admin/events.js")
require("packs/private/admin/events/wizard_form.js")
require("packs/private/admin/events/attendees.js")
window.KTWizardClient = require('packs/private/admin/wizard_form_client.js');
window.KTWizardClientPlan = require('packs/private/admin/wizard_form_client_plan.js');
window.KTWizardUniversity = require('packs/private/admin/wizard_form_university.js');
window.KTWizardLocalCareer = require('packs/private/admin/wizard_form_local_career.js');

// Recruiter
require("packs/private/recruiters/recruiters.js");
require("packs/private/recruiters/update_password.js");
require("packs/private/recruiters/documents.js")
require("packs/private/recruiters/requested_service.js")
require("packs/private/recruiters/services.js")
require("packs/private/recruiters/home.js")

window.KTWizardRecruiter = require('packs/private/recruiters/wizard_form_recruiter.js');
window.KTWizardOfert = require('packs/private/oferts/wizard_form_ofert.js');

// Admin / Recruiter
require("packs/private/accordion.js")

// Cambio de idioma
require("packs/language.js");